export default "__VITE_ASSET__BAUgvMAT__"